import { PdLogin } from "./pd-login/PdLogin.js";
//#region src/pd-login/pd-login.ts
var tag = "pd-login";
if (!customElements.get(tag)) customElements.define(tag, PdLogin);
//#endregion
export { PdLogin };
